import transformData from "./transformData";

export const handleFileUpload = async ({
  event,
  handleUpload,
  processInvoice,
  setTotalInvoices,
  setProcessedInvoices,
  setUploadingNewInvoices,
  setStaticInvoices,
  setSelectedInvoice,
  setSessionInvoices,
  userName,
  materialMasterfile,
  firmDetailsID
}) => {
  console.log('handleFileUpload is called...')
  const files = Array.from(event.target.files);
  if (files.length === 0) return;

  setUploadingNewInvoices(true);
  setProcessedInvoices(0);

  // Prepare initial state for invoices
  const totalInvoiceItems = files.map((file) => ({
    id: Date.now().toString() + Math.random(),
    name: file.name,
    size:
      file.size < 1024
        ? `${file.size} B`
        : file.size < 1024 * 1024
        ? `${(file.size / 1024).toFixed(2)} KB`
        : `${(file.size / (1024 * 1024)).toFixed(2)} KB`,
    progress: 0,
    status: "Starting...",
  }));

  console.log('handleFileUpload totalInvoiceItems : ', totalInvoiceItems);


  setTotalInvoices(totalInvoiceItems);

  // Process all files in parallel immediately
  const uploadPromises = files.map(async (file, index) => {
    const updateProgress = (progress, status) => {
      setTotalInvoices((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          progress,
          status,
        };
        return updated;
      });
    };

    try {
      // Start upload (0-30%)
      console.log('handleFileUpload reached inside try block...');
      updateProgress(0, "Uploading...");
      const uploadResponse = await handleUpload(file);
      if (uploadResponse.status !== "success") throw new Error("Upload failed");
      updateProgress(30, "Processing...");

      // Process invoice (30-60%)
      const extractOrderResponse = await processInvoice(uploadResponse.fileUrl);
      if (extractOrderResponse.status !== "success")
        throw new Error("Processing failed");
      updateProgress(60, "Extracting data...");
      console.log('handleFileUpload going to call transformData');
      // Transform data (60-90%)
      const transformedData = await transformData(
        extractOrderResponse.data,
        uploadResponse.fileUrl,
        materialMasterfile,
        firmDetailsID
      );

      console.log('handleFileUpload transformedData : ', transformedData);
      
      updateProgress(90, "Finalizing...");

      const invoice = {
        ...totalInvoiceItems[index],
        url: uploadResponse.fileUrl,
        requestItemData: transformedData,
        progress: 100,
        status: "Completed",
        newlyAdded: 1,
        date: new Date().toLocaleString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
        uploader: userName,
      };

      // Update final state
      updateProgress(100, "Completed");
      setProcessedInvoices((prev) => prev + 1);
      setStaticInvoices((prev) => [invoice, ...prev]);
      setSessionInvoices((prev) => [...prev, invoice]);

      return invoice;
    } catch (error) {
      console.error(`Error processing file ${file.name}:`, error.message);
      updateProgress(0, `Failed: ${error.message}`);
      return null;
    }
  });

  // Wait for all uploads to complete
  const results = await Promise.all(uploadPromises);
  const successfulInvoices = results.filter((inv) => inv !== null);

  if (successfulInvoices.length > 0) {
    setSelectedInvoice(successfulInvoices[0]);
  }

  setUploadingNewInvoices(false);
};
